import React, { ComponentType } from 'react'
import get from 'lodash/get'

import { Header } from '../Header/Header'
import { MarketingProps } from '../MarketingTag'
import { formatDateLocalized, useLanguage } from '../utils'

export type ResearchItemRenderLinkProps = Partial<ResearchItemProps>

const renderLinkDefault = ({
  slug,
  title = ''
}: ResearchItemRenderLinkProps) => (
  <a aria-label={title} href={`/research/${slug}`}>
    {title}
  </a>
)

export type ResearchItemProps = {
  slug: string
  publishedDate: string
  docType?: string
  reportType?: string
  title: string
  marketing?: MarketingProps
  renderLink?: ComponentType<ResearchItemRenderLinkProps>
  locale?: any
}

export const ResearchItem = (props: ResearchItemProps) => {
  const {
    publishedDate,
    docType,
    reportType,
    marketing,
    renderLink: Link = renderLinkDefault,
    locale = []
  } = props
  const isJapanese = get(marketing, 'language.slug') === 'ja'
  const reportTypeHeader =
    isJapanese &&
    reportType &&
    (reportType.toUpperCase() === 'NON-RATING ACTION COMMENTARY' ||
      reportType.toUpperCase() === 'RATING ACTION COMMENTARY')
      ? locale?.commentary || 'Commentary'
      : reportType

  const { language } = useLanguage()

  return (
    <article className="frw-article__row">
      <div className="frw-heading--sub frw-heading--tag">
        <span
          className={
            get(marketing, 'contentAccessType.name') === 'Premium'
              ? 'frw-premium-report__color'
              : ''
          }
        >
          {docType === 'FW' &&
          reportType &&
          reportType.toUpperCase() === 'NON-RATING ACTION COMMENTARY'
            ? locale['fitch-wire'] || 'Fitch Wire'
            : reportTypeHeader && `${reportTypeHeader}`}
        </span>
        {' / '}
        {formatDateLocalized(publishedDate, 'ccc dd MMM, yyyy', language)}
      </div>
      <Header level={3} className="frw-heading--4">
        <Link {...props} />
      </Header>
    </article>
  )
}
export default ResearchItem
